import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import NavRouter from "./router/NavRouter";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css/animate.min.css";
import "./App.css";
import "./index.css";
import "./style.css";
import "./custom.css";
import "./responsive.css";
import { ToastContainer } from "react-toastify";
import { BaseUrl } from './helper/BaseUrl';
import SEO from './helper/SEO';
import { ModalProvider } from './contexts/ModalContext';

function App({ initialData, initialSeo, initialGlobalSchema }) {
  const [seoData, setSeoData] = useState(initialSeo || null);
  const [globalSchema, setGlobalSchema] = useState(initialGlobalSchema || null);
  const [initialPath] = useState(() => (
    typeof window !== "undefined" ? window.location.pathname : null
  ));
  const location = useLocation();
  const routeInitialData = typeof window === "undefined" || location.pathname === initialPath
    ? initialData
    : undefined;

  const Detailfetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/seo-by-url${location.pathname}`, {
        method: 'GET',
      });
      const result = await response.json();
      if (result.seo === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setSeoData(result.seo);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };
  useEffect(() => {
    Detailfetcher();
  }, [location.pathname])

  useEffect(() => {
    const controller = new AbortController();

    const fetchGlobalSchema = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/global-seo`, {
          method: 'GET',
          signal: controller.signal,
        });
        const result = await response.json();
        setGlobalSchema(result.schema);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error('Global SEO fetch error:', error.message);
        }
      }
    };

    fetchGlobalSchema();
    return () => controller.abort();
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const existingSource = sessionStorage.getItem("source_url");
      if (!existingSource) {
        const landingUrl = window.location.href;
        sessionStorage.setItem("source_url", landingUrl);
      }
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      import("wowjs").then(({ WOW }) => {
        const wow = new WOW({
          live: false,
          mobile: true,
        });
        wow.init();
      });
    }
  }, []);

  return (
    // <BrowserRouter>
    //   <div className="App">
    //      <SEO seoData={seoData} initialSeo={initialSeo}/>
    //     <NavRouter initialData={initialData}  />
    //     <ToastContainer />
    //   </div>
    // </BrowserRouter>

    <>
      <div className="App">
        <SEO seoData={seoData} initialSeo={initialSeo} globalSchema={globalSchema} />
        <ToastContainer />
        <ModalProvider>
          <NavRouter initialData={routeInitialData} />
        </ModalProvider>
      </div>
    </>
  );
}

export default App;
